// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/images/heros/hero-image_2-large.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body, html {
  font-family: 'DM Sans', sans-serif;
  scroll-behavior: smooth;
}

body {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* Style For Navbar */

.skip_link {
  margin-left: 10px;
  padding: 8px;
  position: absolute;
  background: #E77E23;
  height: 30px;
  transform: translateY(-100%);
  transition: transform 0.3s;
}

.skip_link:focus {
  transform: translateY(70%);
}

.skip_link {
  color: #ffffff;
  text-decoration: none;
}

.hamburger-menu {
  display: none;
  cursor: pointer;
}

.bar {
  display: block;
  width: 25px;
  height: 3px;
  margin: 5px 35px 5px 0;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  background-color: black;
}

.app_bar {
  width: auto;
  min-width: 300px;
  height: 74px;
  display: grid;
  align-items: center;
  justify-content: space-between;
  grid-template-columns: 0.3fr 1fr;
  position: sticky;
  top: 0;
  background-color: white;
  border-bottom: 1px solid var(--neutral-2, #DEE5ED);
}

.img_logo {
  height: 44px;
  width: 130px;
  margin-left: 30px;
}

.navbar_list {
  justify-self: end;
  width: auto;
  display: grid;
  justify-content: end;
  justify-items: center;
  align-items: center;
  grid-template-columns: 150px 150px 150px;
  list-style: none;
}

.navbar_item a {
  align-items: center;
  justify-content: center;
  margin: auto;
  display: inline-flex;
  width: 90px;
  height: 44px;
  color: rgb(26, 26, 26);
}

.navbar_item a:link {
  text-decoration: none;
}

.navbar_item a:hover {
  font-weight: 700;
  color: rgb(26, 26, 26);
}

/* Style For First Screen */

.main_hero_container {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center;
  background-size: cover;
  padding: 4rem 2rem;
  height: 50vh;
  min-height: 350px;
}

.container_main_hero_image {
  display: grid;
  align-items: center;
  justify-content: center;
}

.hero_image {
  height: 800px;
  width: auto;
  border-radius: 20px;
  object-fit: cover;
  object-position: 50% 50%;
}

/* Style For Second Screen */

.second_section {
  margin-top: 20px;
  display: grid;
  justify-items: center;
  align-items: center;
}

.popular_restaurant_title {
  display: flex;
  font-size: 2rem;
  font-weight: 700;
  padding: 30px 0;
  align-items: center;
  justify-content: center;
}

.restaurant-list {
  display: grid;
  justify-items: center;
  align-items: center;
  column-gap: 10px;
  row-gap: 25px;
  grid-template-columns: repeat(3, 440px);
  grid-template-rows: repeat(auto-fill, 240px);
}

.resto {
  height: 250px;
}

.restaurant_card {
  width: max-content;
  display: grid;
  justify-items: start;
  align-items: center;
  margin: 30px 0;
  padding: 15px 20px;
  background-color: #ffffff;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
  border-radius: 20px;
  column-gap: 15px;
  grid-template-columns: 190px auto;
}

.container_restaurant {
  display: grid;
  align-items: center;
  row-gap: 10px;
  grid-template-rows: max-content;
}

.restaurant_description {
  font-size: 13px;
  text-align: justify;
  height: 90px;
  line-height: 1.1rem;
  align-self: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box !important;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  white-space: normal;
}

.container_rating_location {
  font-size: 13px;
  display: grid;
  align-items: center;
  grid-template-columns: 20px 35px 20px auto;
}

.bi-star-fill {
  color: rgb(255, 166, 0);
}

.bi-geo-alt-fill {
  color: #dd0303;
}

.button_book_now {
  width: 130px;
  height: 47px;
  font-size: 15px;
  margin-top: 10px;
  display: flex;
  text-decoration: none;
  color: white;
  cursor: pointer;
  border-radius: 50px;
  align-items: center;
  justify-content: center;
  background: var(--neutral-10, #9ac000e3);
}

.button_book_now:hover {
  font-weight: 700;
  background: var(--neutral-10, #cc341de3);
}

.container_restaurant_image {
  display: grid;
  justify-content: center;
  align-items: center;
}

.restaurant_image {
  border-radius: 10px;
}

/* Style For Footer */
footer {
  margin-top: auto;
}

.container_footer {
  width: auto;
  min-width: 300px;
  margin-top: 80px;
  height: 150px;
  display: grid;
  justify-items: center;
  align-items: center;
  padding: 30px 0;
  background-color: #f6fff8;
  grid-template-columns: repeat(3, 1fr);
  border-top: 1px solid var(--neutral-2, #DEE5ED);
}

.footer_main_title {
  font-size: 30px;
}

.container-social-media {
  display: grid;
  justify-items: center;
  align-items: center;
  row-gap: 10px;
  grid-template-columns: 360px;
  grid-template-rows: 20px auto;
}

.follow_us {
  font-size: 21px;
  font-weight: 700;
}

.list-social-media {
  display: grid;
  justify-items: start;
  list-style: none;
  column-gap: 30px;
  grid-template-columns: 80px 70px 80px 60px;
}

.list-social-media a {
  align-items: center;
  margin: auto;
  display: inline-flex;
  height: 44px;
  column-gap: 10px;
  color: rgb(26, 26, 26);
}

.instagram {
  flex: 1;
}

.list-social-media a:link {
  text-decoration: none;
}

.list-social-media a:hover {
  font-weight: 500;
}


/* Detail Restaurant Page */

.restaurant_detail {
  display: grid;
  grid-template-columns: 700px 550px;
  grid-template-rows: auto;
  column-gap: 30px;
  justify-content: center;
  margin-top: 70px;
}

.detail_container {
  height: max-content;
  display: grid;
  align-items: center;
  grid-template-columns: repeat(1, 1fr);
  grid-template-rows: 410px 410px 60px;
  padding: 40px 0;
  justify-items: center;
  background-color: #ffffff;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  row-gap: 20px;
}

.detail_restaurant_image {
 width: 600px;
 border-radius: 10px;
}

.restaurant_info {
  width: 600px;
  display: grid;
  row-gap: 10px;
}

.detail_container_rating_location {
  font-size: 18px;
  font-weight: 500;
  display: grid;
  align-items: center;
  grid-template-columns: 20px 35px 20px auto;
}

.detail_description {
  text-align: justify;
  font-size: 17px;
  color: rgb(65, 65, 65);
}

.categories {
  display: grid;
  grid-template-columns: repeat(2, 140px);
}

.name_categories {
  width: 130px;
  height: 47px;
  font-size: 17px;
  margin-top: 10px;
  display: flex;
  text-decoration: none;
  color: white;
  border-radius: 50px;
  align-items: center;
  justify-content: center;
  background: var(--neutral-10, #9ac000e3);
}

.restaurant_menu {
  height: max-content;
  display: grid;
  align-items: center;
  grid-template-columns: repeat(1, 1fr);
  grid-template-rows: repeat(auto-fill, 50px);
  padding: 20px 0;
  justify-items: center;
  background-color: #ffffff;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
  border-radius: 10px;
}

.restaurant_menu h3{
  font-size: 23px;
  color: #212529;
}

.food_menu {
  color: #212529;
  font-size: 20px;
  margin-left: 50px;
  justify-self: flex-start;  
}

.food_menu h4 {
  font-size: 20px;
  font-weight: 500;
}

.food_menu li {
  font-size: 18px;
  margin-top: 10px;
  margin-left: 35px;
}

.drink_menu {
  color: #212529;
  font-size: 20px;
  margin-left: 50px;
  justify-self: flex-start;
}

.drink_menu h4 {
  font-size: 20px;
  margin-top: 20px;
  font-weight: 500;
}

.drink_menu li {
  font-size: 18px;
  margin-top: 10px;
  margin-left: 35px;
}

/* Like */
.likeButtonContainer {
  margin-right: 50px;
  justify-self: flex-end;
}

.like {
  width: 55px;
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #db0000;

  bottom: 16px;
  right: 16px;
  border-radius: 50%;
  border: 0;
  
  font-size: 18px;
  color: white;
  cursor: pointer;
}


.favorite_restaurant_container {
  margin-top: 30px;
  display: grid;
  justify-items: center;
  grid-template-columns: repeat(1, 1fr);
  grid-template-rows: 80px auto;
}

.favorite_restaurant_container h2 {
  font-size: 2rem;
  font-weight: 700;
  align-self: center;
}

.favorite_restaurant_container .no_data {
  font-weight: 500;
  font-size: 1.7rem;
}
`, "",{"version":3,"sources":["webpack://./src/styles/main.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA,qBAAqB;;AAErB;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,wCAAwC;EACxC,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gCAAgC;EAChC,gBAAgB;EAChB,MAAM;EACN,uBAAuB;EACvB,kDAAkD;AACpD;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,2BAA2B;;AAE3B;EACE,0DAAwE;EACxE,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA,4BAA4B;;AAE5B;EACE,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,uCAAuC;EACvC,4CAA4C;AAC9C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,+BAA+B;EAC/B,qBAAqB;EACrB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,qCAAqC;EACrC,+CAA+C;AACjD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,aAAa;EACb,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;;AAGA,2BAA2B;;AAE3B;EACE,aAAa;EACb,kCAAkC;EAClC,wBAAwB;EACxB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,oCAAoC;EACpC,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;AACf;;AAEA;CACC,YAAY;CACZ,mBAAmB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAC3C,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;;EAEzB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,SAAS;;EAET,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;;AAGA;EACE,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,qCAAqC;EACrC,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&display=swap');\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody, html {\n  font-family: 'DM Sans', sans-serif;\n  scroll-behavior: smooth;\n}\n\nbody {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Style For Navbar */\n\n.skip_link {\n  margin-left: 10px;\n  padding: 8px;\n  position: absolute;\n  background: #E77E23;\n  height: 30px;\n  transform: translateY(-100%);\n  transition: transform 0.3s;\n}\n\n.skip_link:focus {\n  transform: translateY(70%);\n}\n\n.skip_link {\n  color: #ffffff;\n  text-decoration: none;\n}\n\n.hamburger-menu {\n  display: none;\n  cursor: pointer;\n}\n\n.bar {\n  display: block;\n  width: 25px;\n  height: 3px;\n  margin: 5px 35px 5px 0;\n  -webkit-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n  background-color: black;\n}\n\n.app_bar {\n  width: auto;\n  min-width: 300px;\n  height: 74px;\n  display: grid;\n  align-items: center;\n  justify-content: space-between;\n  grid-template-columns: 0.3fr 1fr;\n  position: sticky;\n  top: 0;\n  background-color: white;\n  border-bottom: 1px solid var(--neutral-2, #DEE5ED);\n}\n\n.img_logo {\n  height: 44px;\n  width: 130px;\n  margin-left: 30px;\n}\n\n.navbar_list {\n  justify-self: end;\n  width: auto;\n  display: grid;\n  justify-content: end;\n  justify-items: center;\n  align-items: center;\n  grid-template-columns: 150px 150px 150px;\n  list-style: none;\n}\n\n.navbar_item a {\n  align-items: center;\n  justify-content: center;\n  margin: auto;\n  display: inline-flex;\n  width: 90px;\n  height: 44px;\n  color: rgb(26, 26, 26);\n}\n\n.navbar_item a:link {\n  text-decoration: none;\n}\n\n.navbar_item a:hover {\n  font-weight: 700;\n  color: rgb(26, 26, 26);\n}\n\n/* Style For First Screen */\n\n.main_hero_container {\n  background: url('../public/images/heros/hero-image_2-large.webp') center;\n  background-size: cover;\n  padding: 4rem 2rem;\n  height: 50vh;\n  min-height: 350px;\n}\n\n.container_main_hero_image {\n  display: grid;\n  align-items: center;\n  justify-content: center;\n}\n\n.hero_image {\n  height: 800px;\n  width: auto;\n  border-radius: 20px;\n  object-fit: cover;\n  object-position: 50% 50%;\n}\n\n/* Style For Second Screen */\n\n.second_section {\n  margin-top: 20px;\n  display: grid;\n  justify-items: center;\n  align-items: center;\n}\n\n.popular_restaurant_title {\n  display: flex;\n  font-size: 2rem;\n  font-weight: 700;\n  padding: 30px 0;\n  align-items: center;\n  justify-content: center;\n}\n\n.restaurant-list {\n  display: grid;\n  justify-items: center;\n  align-items: center;\n  column-gap: 10px;\n  row-gap: 25px;\n  grid-template-columns: repeat(3, 440px);\n  grid-template-rows: repeat(auto-fill, 240px);\n}\n\n.resto {\n  height: 250px;\n}\n\n.restaurant_card {\n  width: max-content;\n  display: grid;\n  justify-items: start;\n  align-items: center;\n  margin: 30px 0;\n  padding: 15px 20px;\n  background-color: #ffffff;\n  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);\n  border-radius: 20px;\n  column-gap: 15px;\n  grid-template-columns: 190px auto;\n}\n\n.container_restaurant {\n  display: grid;\n  align-items: center;\n  row-gap: 10px;\n  grid-template-rows: max-content;\n}\n\n.restaurant_description {\n  font-size: 13px;\n  text-align: justify;\n  height: 90px;\n  line-height: 1.1rem;\n  align-self: center;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box !important;\n  -webkit-line-clamp: 5;\n  -webkit-box-orient: vertical;\n  white-space: normal;\n}\n\n.container_rating_location {\n  font-size: 13px;\n  display: grid;\n  align-items: center;\n  grid-template-columns: 20px 35px 20px auto;\n}\n\n.bi-star-fill {\n  color: rgb(255, 166, 0);\n}\n\n.bi-geo-alt-fill {\n  color: #dd0303;\n}\n\n.button_book_now {\n  width: 130px;\n  height: 47px;\n  font-size: 15px;\n  margin-top: 10px;\n  display: flex;\n  text-decoration: none;\n  color: white;\n  cursor: pointer;\n  border-radius: 50px;\n  align-items: center;\n  justify-content: center;\n  background: var(--neutral-10, #9ac000e3);\n}\n\n.button_book_now:hover {\n  font-weight: 700;\n  background: var(--neutral-10, #cc341de3);\n}\n\n.container_restaurant_image {\n  display: grid;\n  justify-content: center;\n  align-items: center;\n}\n\n.restaurant_image {\n  border-radius: 10px;\n}\n\n/* Style For Footer */\nfooter {\n  margin-top: auto;\n}\n\n.container_footer {\n  width: auto;\n  min-width: 300px;\n  margin-top: 80px;\n  height: 150px;\n  display: grid;\n  justify-items: center;\n  align-items: center;\n  padding: 30px 0;\n  background-color: #f6fff8;\n  grid-template-columns: repeat(3, 1fr);\n  border-top: 1px solid var(--neutral-2, #DEE5ED);\n}\n\n.footer_main_title {\n  font-size: 30px;\n}\n\n.container-social-media {\n  display: grid;\n  justify-items: center;\n  align-items: center;\n  row-gap: 10px;\n  grid-template-columns: 360px;\n  grid-template-rows: 20px auto;\n}\n\n.follow_us {\n  font-size: 21px;\n  font-weight: 700;\n}\n\n.list-social-media {\n  display: grid;\n  justify-items: start;\n  list-style: none;\n  column-gap: 30px;\n  grid-template-columns: 80px 70px 80px 60px;\n}\n\n.list-social-media a {\n  align-items: center;\n  margin: auto;\n  display: inline-flex;\n  height: 44px;\n  column-gap: 10px;\n  color: rgb(26, 26, 26);\n}\n\n.instagram {\n  flex: 1;\n}\n\n.list-social-media a:link {\n  text-decoration: none;\n}\n\n.list-social-media a:hover {\n  font-weight: 500;\n}\n\n\n/* Detail Restaurant Page */\n\n.restaurant_detail {\n  display: grid;\n  grid-template-columns: 700px 550px;\n  grid-template-rows: auto;\n  column-gap: 30px;\n  justify-content: center;\n  margin-top: 70px;\n}\n\n.detail_container {\n  height: max-content;\n  display: grid;\n  align-items: center;\n  grid-template-columns: repeat(1, 1fr);\n  grid-template-rows: 410px 410px 60px;\n  padding: 40px 0;\n  justify-items: center;\n  background-color: #ffffff;\n  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);\n  border-radius: 10px;\n  row-gap: 20px;\n}\n\n.detail_restaurant_image {\n width: 600px;\n border-radius: 10px;\n}\n\n.restaurant_info {\n  width: 600px;\n  display: grid;\n  row-gap: 10px;\n}\n\n.detail_container_rating_location {\n  font-size: 18px;\n  font-weight: 500;\n  display: grid;\n  align-items: center;\n  grid-template-columns: 20px 35px 20px auto;\n}\n\n.detail_description {\n  text-align: justify;\n  font-size: 17px;\n  color: rgb(65, 65, 65);\n}\n\n.categories {\n  display: grid;\n  grid-template-columns: repeat(2, 140px);\n}\n\n.name_categories {\n  width: 130px;\n  height: 47px;\n  font-size: 17px;\n  margin-top: 10px;\n  display: flex;\n  text-decoration: none;\n  color: white;\n  border-radius: 50px;\n  align-items: center;\n  justify-content: center;\n  background: var(--neutral-10, #9ac000e3);\n}\n\n.restaurant_menu {\n  height: max-content;\n  display: grid;\n  align-items: center;\n  grid-template-columns: repeat(1, 1fr);\n  grid-template-rows: repeat(auto-fill, 50px);\n  padding: 20px 0;\n  justify-items: center;\n  background-color: #ffffff;\n  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);\n  border-radius: 10px;\n}\n\n.restaurant_menu h3{\n  font-size: 23px;\n  color: #212529;\n}\n\n.food_menu {\n  color: #212529;\n  font-size: 20px;\n  margin-left: 50px;\n  justify-self: flex-start;  \n}\n\n.food_menu h4 {\n  font-size: 20px;\n  font-weight: 500;\n}\n\n.food_menu li {\n  font-size: 18px;\n  margin-top: 10px;\n  margin-left: 35px;\n}\n\n.drink_menu {\n  color: #212529;\n  font-size: 20px;\n  margin-left: 50px;\n  justify-self: flex-start;\n}\n\n.drink_menu h4 {\n  font-size: 20px;\n  margin-top: 20px;\n  font-weight: 500;\n}\n\n.drink_menu li {\n  font-size: 18px;\n  margin-top: 10px;\n  margin-left: 35px;\n}\n\n/* Like */\n.likeButtonContainer {\n  margin-right: 50px;\n  justify-self: flex-end;\n}\n\n.like {\n  width: 55px;\n  height: 55px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #db0000;\n\n  bottom: 16px;\n  right: 16px;\n  border-radius: 50%;\n  border: 0;\n  \n  font-size: 18px;\n  color: white;\n  cursor: pointer;\n}\n\n\n.favorite_restaurant_container {\n  margin-top: 30px;\n  display: grid;\n  justify-items: center;\n  grid-template-columns: repeat(1, 1fr);\n  grid-template-rows: 80px auto;\n}\n\n.favorite_restaurant_container h2 {\n  font-size: 2rem;\n  font-weight: 700;\n  align-self: center;\n}\n\n.favorite_restaurant_container .no_data {\n  font-weight: 500;\n  font-size: 1.7rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
